export enum UICondition { notset, positive, warning, negative, info, brand, none };
export enum UISize { notset, small, normal, large, xlarge, massive };
export enum UIBreakMode { none, phone, tablet };
export enum UIMarginBottom { none, small, medium, large };

const conditions = {
  positive: "ui-condition-positive",
  warning: "ui-condition-warning",
  negative: "ui-condition-negative",
  info: "ui-condition-info",
  brand: "ui-condition-brand",
  none: "ui-condition-none"
}

const sizes = {
  small: "ui-size-small",
  normal: "ui-size-normal",
  large: "ui-size-large",
  xlarge: "ui-size-xlarge",
  massive: "ui-size-massive",
}

const breaks = {
  phone: "ui-responsive-phone",
  tablet: "ui-responsive-phone ui-responsive-tablet"
}


export class UIHelpers {
  static SizeClasses = sizes;
  static ConditionClasses = conditions;
  static BreakClasses = breaks;
  static Sizes = UISize;
  static Conditions = UICondition;
  static BreakMode = UIBreakMode;

  static GetSizeClass(size: UISize, defaultSize = sizes.normal) {
    return "ui-size " + UIHelpers.GetSizeClassInner(size, defaultSize)
  }

  static GetMarginBottomClass(marginBottom: UIMarginBottom) {
    return marginBottom ? "margin-bottom-" + UIHelpers.GetMarginBottomClassInner(marginBottom) : null;
  }

  private static GetMarginBottomClassInner(marginBottom: UIMarginBottom) {
    switch (marginBottom) {
      case UIMarginBottom.small:
        return "small";
      case UIMarginBottom.medium:
        return "medium";
      case UIMarginBottom.large:
        return "large";
      default:
        return null;
    }
  }

  private static GetSizeClassInner(size: UISize, defaultSize = sizes.normal) {
    switch (size) {
      case UISize.small:
        return sizes.small;
      case UISize.normal:
        return sizes.normal;
      case UISize.large:
        return sizes.large;
      case UISize.xlarge:
        return sizes.xlarge;
      case UISize.massive:
        return sizes.massive;
      default:
        return defaultSize;
    }
  }

  static GetConditionClass(condition: UICondition) {
    return "ui-condition " + UIHelpers.GetConditionClassInner(condition);
  }

  private static GetConditionClassInner(condition: UICondition) {
    switch (condition) {
      case UICondition.positive:
        return conditions.positive;
      case UICondition.warning:
        return conditions.warning;
      case UICondition.negative:
        return conditions.negative;
      case UICondition.info:
        return conditions.info;
      case UICondition.brand:
        return conditions.brand;
      case UICondition.none:
        return conditions.none;
      default:
        return null;
    }
  }

  static GetResponsiveBreakClass(breakMode: UIBreakMode) {
    if (breakMode){
      return "ui-responsive " + UIHelpers.GetResponsiveBreakClassInner(breakMode);
    }
    return null;
  }

  private static GetResponsiveBreakClassInner(breakMode: UIBreakMode) {
    switch (breakMode) {
      case UIBreakMode.phone:
        return breaks.phone;
      case UIBreakMode.tablet:
        return breaks.tablet;
      default:
        return null;
    }
  }
}
